import * as graphql from 'generated/graphql';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';

import PlaceholderDisplay from './PlaceholderDisplay';

export default function OpenQuestionDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	if (
		props.item.openQuestion &&
		props.item.openQuestion.ops
			.map((op: { insert?: string }) => op.insert ?? '')
			.join('')
			.trim().length > 0
	) {
		return <QuillText quill={props.item.openQuestion ?? { ops: [] }} />;
	}

	return <PlaceholderDisplay />;
}
